export default "__VITE_ASSET__2SKKO5RR__"